import { APICore } from "./apiCore";

const api = new APICore();

function getUsers() {
  const baseUrl = `/web/users`;
  return api.get(`${baseUrl}`, {});
}

function updateUserStatusApi(params: { userId: string; status: string }) {
  const baseUrl = "/web/user-status";
  return api.updatePatch(`${baseUrl}/${params.userId}`, {});
}

function blockUserApi(userId: string) {
  const baseUrl = "/web/users";
  return api.updatePatch(`${baseUrl}/${userId}`, {});
}

export { getUsers, updateUserStatusApi, blockUserApi };
